import React from 'react';

const CardWrapper = ({ extraClasses, children, display }) => {

  if (!display)
    return null;
    
  return (
    <section className={`main-content-section ${extraClasses}`}>
        { children }
    </section>
  );
}

export default CardWrapper;